// src/shared/realtime/signalr-connection.ts
import { HubConnectionBuilder, LogLevel, type HubConnection, type ILogger } from '@microsoft/signalr';
import { env } from '@/config/env';

// Quiet logger: suppress the StrictMode double-mount reconnect noise in dev.
const quietLogger: ILogger = {
  log: (level, message) => {
    if (level >= LogLevel.Warning) console.warn(`[signalr] ${message}`);
  },
};

export function createHubConnection(
  hubPath: string,
  getAccessToken: () => Promise<string> | string,
): HubConnection {
  const connection = new HubConnectionBuilder()
    .withUrl(`${env.apiBaseUrl}${hubPath}`, {
      accessTokenFactory: () => Promise.resolve(getAccessToken()),
      withCredentials: false, // Bearer JWT, no cookies
    })
    .withAutomaticReconnect()
    .configureLogging(quietLogger)
    .build();

  // Sane web defaults — Flutter's values (10_000_000 / 500_000_000) break the JS client.
  connection.serverTimeoutInMilliseconds = 60_000;
  connection.keepAliveIntervalInMilliseconds = 15_000;
  return connection;
}
